import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { Toaster } from 'sonner';
import Layout from './components/Layout';
import AuthGuard from './components/AuthGuard';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import CreateProject from './pages/CreateProject';
import ProjectView from './pages/ProjectView';
import Settings from './pages/Settings';
import Analytics from './pages/Analytics';
import FullEditor from './pages/FullEditor';
import Profile from './pages/Profile';
import Docs from './pages/Docs';
import Terms from './pages/Terms';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" toastOptions={{ style: { background: '#111111', color: '#FAFAFA', border: '1px solid #1A1A1A', borderRadius: '12px' } }} />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/terms" element={<Terms />} />
          <Route element={<AuthGuard />}>
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/new" element={<CreateProject />} />
              <Route path="/project/:id" element={<ProjectView />} />
              <Route path="/project/:id/settings" element={<Settings />} />
              <Route path="/project/:id/analytics" element={<Analytics />} />
              <Route path="/project/:id/editor" element={<FullEditor />} />
              <Route path="/profile" element={<Profile />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
